import type {
  /* Formatting */
  ValueDefinitionMap,
} from '@hotwired/stimulus/dist/types/core/value_properties';

import ApplicationController from '../application-controller';

type InputTarget = HTMLInputElement | HTMLTextAreaElement;

export default class extends ApplicationController {
  static values: ValueDefinitionMap = {
    maxCount: Number,
  };

  declare maxCountValue?: number;
  declare readonly hasMaxCountValue: boolean;

  static targets: string[] = ['input', 'display'];

  declare readonly inputTarget?: InputTarget;
  declare readonly hasInputTarget: boolean;

  declare readonly displayTarget?: HTMLElement;
  declare readonly hasDisplayTarget: boolean;

  connect(): void {
    super.connect();

    if (this.hasInputTarget && this.inputTarget) {
      this.updateCount(this.inputTarget.value.length);
    }
  }

  private updateCount(count: number) {
    if (this.hasMaxCountValue && this.maxCountValue) {
      const boundCount = Math.min(count, this.maxCountValue);

      if (this.hasDisplayTarget && this.displayTarget) {
        this.displayTarget.innerText = [
          boundCount,
          '/',
          this.maxCountValue,
        ].join('');
      }

      if (count >= this.maxCountValue) {
        this.data.set('invalid', '');

        if (this.hasInputTarget && this.inputTarget) {
          this.inputTarget.value = this.inputTarget.value.slice(
            0,
            this.maxCountValue,
          );
        }
      } else {
        this.data.delete('invalid');
      }
    }
  }

  update(event: InputEvent) {
    const { target } = event;

    if (target) {
      const { value } = target as InputTarget;

      if (typeof value === 'string') {
        this.updateCount(value.length);
      }
    }
  }
}
